import React from 'react';
import TranslateFile from '../../../../../config/TranslateFile';


const formatPhoneNumber = (phone) => {
  // Remove non-digit characters
  const digits = phone.replace(/\D/g, '');

  // Format as (888) 888-8888
  const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    return !match[2]
      ? `(${match[1]}`
      : `(${match[1]}) ${match[2]}${match[3] ? '-' + match[3] : ''}`;
  }

  return phone;
};

const FormatPhoneNumber = ({ name, value, onChange, onBlur, error, onKeyDown }) => {

  const currentLang = TranslateFile();

  const handleChange = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    onChange({ target: { name, value: formattedValue } });
  };

  return (
    <div>
      <label
        className="form-label w-100 fs-5 inmate-label"
      // style={{ color: "#2c2f32", fontWeight: "400" }}
      >
        {currentLang?.MyAccountPage?.Phone_Number} <span className="text-danger">*</span>
      </label>
      <div>
        <input
          type="text"
          name={name}
          className={`form-control mb-3 fs-5 ${error ? 'border-danger' : ''} fw-normal`} // Same classes as TextInput
          placeholder="(888) 888-8888"
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          required={false}
          onKeyDown={onKeyDown}
        />
        {error && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormatPhoneNumber;
